import * as React from "react";
import {Grid} from "@mui/material";
import {Currency} from "../../../../../../../config/currencies";
import {convertAmountToFloat} from "../../../../../../../helpers/transaction_helpers";
import { OutlinedContainer } from "../../../../../../Components/Form/OutlinedContainer";
import { Form } from "../../../../../../Components/Form/Form/Form";
import { SelectField } from "../../../../../../Components/Form/SelectField";
import { IForm } from "../../../../../../../hooks/use_form_v2";
import { ITransactionSplit } from "../../../../../../../config/transactions";

interface ISplitMethodPercentageFieldProps {
    form?: IForm<ITransactionSplit>;
    originalAmount: string;
    originalCurrency: Currency;
}

export const SplitMethodPercentageField = ({form, originalAmount, originalCurrency}: ISplitMethodPercentageFieldProps) => {
    const { register, watch } = form!;

    return (
        <>
            <Form.Field
                type={SelectField}
                {...register('percentage')}
                options={Array.from({length: 100}, (_, i) => i + 1)}
                optionValueGetter={(o: any) => o}
                optionLabelGetter={(o: any) => `${o}%`}
                gridProps={{xs: 6, md: 3}}
            />

            <Grid size={{xs: 6, md: 5}}>
                <OutlinedContainer label="Amount">
                    <strong>
                        {((convertAmountToFloat(originalAmount) * watch('percentage') / 100) as any).toCurrency(originalCurrency)}
                    </strong>
                </OutlinedContainer>
            </Grid>
        </>
    );
}
